<!--Select receiving person-->
<div class="row" *ngIf="!creatingNewContact">
  <div class="col-md-6">
    <cwc-picker
      [label]="'views.one_click.receiving_person' | translate"
      [formControl]="locationPageFormGroup.controls[LocationElements.RECEIVING_PERSON]"
      formcontrolName="locationElements.RECEIVING_PERSON"
      [filter]="true"
      (cwcChange)="contactSelectCHanged($event.detail)"
      [placeholder]="'views.location.select_contact' | translate"
      [status]="formControl.invalid && formControl.touched ? 'error' : 'regular'"
      [statusMessage]="formControlMessageError.getMessage(formControl)"
      [required]="formControl.hasError('required')"
      [filterPlaceholder]="'views.location.search' | translate"
      [filterEmptyMessage]="'views.location.no_receiving_person' | translate"
      designVersion="v2"
    >
      <option *ngFor="let option of options" [value]="option.id" class="person-select-option">
        <div>
          <span>{{ option.name }} </span>
          <span
            *ngIf="option.phone && option['phone'].length > 0"
            class="form-field__selection&#45;&#45;phone-option"
            >{{ option?.phone | formatPhone }}</span
          >
        </div>
      </option>
    </cwc-picker>
  </div>
  <div class="col-md-6">
    <cwc-button
      class="button-ghost no-border margin-top-25"
      cmx-button
      color="support"
      (click)="toggleCreatingNewContact()"
    >
      {{ 'views.location.new_person' | translate }}
    </cwc-button>
  </div>
</div>
<!--Create Receiving Person-->
<div class="row" *ngIf="creatingNewContact">
  <div class="col-md-5 col-sm-12 create-person-form__input">
    <cwc-input
      [label]="'views.one_click.receiving_person_name' | translate"
      [placeholder]="'views.location.name' | translate"
      [ngModel]="receivingPersonName"
      [status]="formControl.invalid && !formControl.untouched ? 'error' : 'regular'"
      [statusMessage]="this.formControl.hasError('required') ? ('forms.required' | translate) : ''"
      (ngModelChange)="contactNameChanged($event)"
      designVersion="v2"
    ></cwc-input>
  </div>

  <div class="col-md-4 col-sm-12 create-person-form__input">
    <cwc-input
      [label]="'views.one_click.receiving_person_phone' | translate"
      [placeholder]="'views.location.phone' | translate"
      [ngModel]="receivingPersonPhone"
      [statusMessage]="this.formControl.hasError('required') ? ('forms.required' | translate) : ''"
      (ngModelChange)="contactPhoneChanged($event)"
      designVersion="v2"
    ></cwc-input>
  </div>
  <cwc-button
    class="col-md-3 close-form button-ghost button-close no-border"
    cmx-button
    color="support"
    (click)="toggleCreatingNewContact()"
    designVersion="v2"
  >
    {{ 'views.location.cancel' | translate }}
  </cwc-button>
</div>
